import {paths} from 'middleware/config';
import {rb} from 'middleware/rb';

const {newsletterPath} = paths;

export async function addEmail(email) {
  const {path, options} = await rb(`${newsletterPath}/email`, {}, 'POST', {email});
  return fetch(path, options).then(d => d.json());
}
